var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card"},[_c('span',{staticClass:"content"},[_vm._t("default")],2),_c('span',{staticClass:"icon",attrs:{"test-id":"info_card-icon"}},[_vm._v("i")])])}
var staticRenderFns = []

export { render, staticRenderFns }